import {RouteConfig} from 'vue-router/types/router';

/** Public pages around the login (the login itself stays in index.ts): Passwort vergessen, Passwort gespeichert, Abgemeldet */
export const AUTH_ROUTES: RouteConfig[] = [
    {
        path: '/forgot-password',
        name: 'Passwort vergessen',
        component: () => import(/* webpackChunkName: "auth-pages" */ '@/views/ForgotPasswordView.vue'),
        meta: {
            guestOnly: true,
        },
    },
    {
        path: '/signup-complete',
        name: 'Passwort gespeichert',
        component: () => import(/* webpackChunkName: "auth-pages" */ '@/views/SignupCompleteView.vue'),
        meta: {
            guestOnly: true,
        },
    },
    {
        path: '/logged-out',
        name: 'Abgemeldet',
        component: () => import(/* webpackChunkName: "auth-pages" */ '@/views/LoggedOutView.vue'),
        meta: {
            forAll: true,
            hideNavbar: true,
        },
    },
];
